// extracted by mini-css-extract-plugin
export var wordContainer = "_ng-0";